import {
  Corner,
  Root,
  ScrollAreaScrollbar,
  ScrollAreaThumb,
  Viewport,
} from '@radix-ui/react-scroll-area';
import { type ComponentProps, type ReactElement } from 'react';
import { cn } from '@avanta/shared/utils/cn';
import { scrollAreaStyles } from './styles';

const ScrollArea = ({
  className,
  children,
  ...props
}: ComponentProps<typeof Root>): ReactElement => (
  <Root data-slot="scroll-area" className={cn(scrollAreaStyles.scrollArea, className)} {...props}>
    <Viewport data-slot="scroll-area-viewport" className={scrollAreaStyles.scrollAreaViewport}>
      {children}
    </Viewport>
    <ScrollBar />
    <Corner />
  </Root>
);

const ScrollBar = ({
  className,
  orientation = 'vertical',
  ...props
}: ComponentProps<typeof ScrollAreaScrollbar>): ReactElement => (
  <ScrollAreaScrollbar
    data-slot="scroll-area-scrollbar"
    orientation={orientation}
    className={cn(
      scrollAreaStyles.scrollBarBase,
      orientation === 'vertical' && scrollAreaStyles.scrollBarVertical,
      orientation === 'horizontal' && scrollAreaStyles.scrollBarHorizontal,
      className
    )}
    {...props}
  >
    <ScrollAreaThumb data-slot="scroll-area-thumb" className={scrollAreaStyles.scrollAreaThumb} />
  </ScrollAreaScrollbar>
);

export { ScrollArea, ScrollBar };
